export default __webpack_public_path__ + "static/media/chickennuggets-wide@2x.a166a20f.jpg";